import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { CompanyOutput, entityName } from '@qtek/shared/models';

import { HttpEntityManager } from './../http-entity-manager';

@Injectable({
  providedIn: 'root',
})
export class CompanyService extends HttpEntityManager<CompanyOutput, any> {
  protected http = inject(HttpClient);

  entityName: entityName = 'Company';

  constructor() {
    super();
  }

  updateCompany(
    payload: Partial<CompanyOutput>,
    companyId: string,
    queryParams: any = {}
  ) {
    return super.put(payload, companyId, queryParams);
  }
}
